import '@jetbrains/ring-ui/dist/style.css'
import '@qodana/blocks/lib/styles/styles.css'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import React from 'react'
import ReactDOM from 'react-dom'

import './index.css'

import App from './App'
import { worker } from './mocks/browser'
import reportWebVitals from './reportWebVitals'
import { CLOUD_PACKAGE_VERSION } from './version'

let REACT_APP_SENTRY_DSN: string | undefined

try {
	;({ REACT_APP_SENTRY_DSN } = process.env)
} catch {
	console.error('cannot get value from process.env')
}

if (REACT_APP_SENTRY_DSN) {
	Sentry.init({
		dsn: REACT_APP_SENTRY_DSN,
		integrations: [new Integrations.BrowserTracing()],
		release: `cloud@${CLOUD_PACKAGE_VERSION}`,

		// Set tracesSampleRate to 1.0 to capture 100%
		// of transactions for performance monitoring.
		// We recommend adjusting this value in production
		tracesSampleRate: 1.0,
	})
}

async function beforeRender(): Promise<void> {
	const { REACT_APP_USE_MOCK_SERVICE_WORKER } = process.env
	if ((REACT_APP_USE_MOCK_SERVICE_WORKER || '').toLowerCase() === 'true') {
		try {
			// Initialize the msw worker, wait for the service worker registration to resolve, then mount
			await worker.start()
		} catch (ex) {
			console.error(ex)
		}
	}
}

beforeRender().then(() => {
	ReactDOM.render(
		<React.StrictMode>
			<App />
		</React.StrictMode>,
		document.getElementById('qodanaCloudRoot'),
	)
})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
